import axios from 'axios'
import { MyMenusPath } from '../constants';

// const FB_APP_ID = window.location.host.indexOf('musthavemenus') > 0 ? '205205622890888' : '818585078219603';
const FB_APP_ID = '5982528115104366';
const FB_SDK = window.location.host.indexOf('musthavemenus') > 0 ? "https://connect.facebook.net/en_US/sdk.js" : "https://connect.facebook.net/en_US/sdk/debug.js";
const FB_VERSION = 'v15.0';

//---------------- FACEBOOK ----------------//
const initFb = function(callback) {
    window.fbAsyncInit = function() {
        FB.init({
            appId      : FB_APP_ID,
            version    : FB_VERSION,
            status     : true,
            cookie     : true,
            xfbml	   : true,
            autoLogAppEvents : true
        });
        FB.AppEvents.logPageView();
        if (!!callback) callback();
    };
    (function(d, s, id){
        var js, fjs = d.getElementsByTagName(s)[0];
        if (d.getElementById(id)) {return;}
        js = d.createElement(s); js.id = id; js.async = true;
        js.src = FB_SDK;
        fjs.parentNode.insertBefore(js, fjs);
    }(document, 'script', 'facebook-jssdk'));
}

const getFbUserName = function(onSuccess) {
    FB.api(`/${FB_VERSION}/me?fields=id,name`, function(response) {
        if ( ! response.error) {
            onSuccess(response.name);
        }
    });
}

const getFbPermissions = function(onSuccess, onError, ignoreStatus) {
    FB.getLoginStatus(function(response) {
        if (!ignoreStatus && response.status === 'connected') {
            onSuccess(response);
        } else {
            FB.login(
                function(response) {
                    if (response.authResponse) {
                        onSuccess(response);
                    } else {
                        onError(response);
                    }
                },
                {
                    scope: "pages_manage_posts, pages_show_list, public_profile, email",
                    auth_type: 'reauthorize',
                    return_scopes: true,
                    enable_profile_selector: true
                }
            );
        }
    });
}

const getFbPages = function(onSuccess, onError) {
    FB.api(`/${FB_VERSION}/me/accounts`, function(response) {
        if ( ! response.error) {
            var pages = [];
            response.data.forEach(function(page){
                if (page.category != 'Application') pages.push(page);
            });
            onSuccess(pages);
        } else {
            if (!!onError) onError("failure");
        }
    });
}

const getFbPageData = function(pageId, accessToken, onSuccess, onFailure, httpMethod) {
    if(typeof httpMethod == 'undefined'){
        httpMethod = 'get';
    }
    var requestURL,requestParams;
    if(httpMethod == 'get'){
        requestURL = `/${FB_VERSION}/` + pageId + '/tabs/app_' + FB_APP_ID;
        requestParams = {access_token: accessToken};
    }else{
        requestURL = `/${FB_VERSION}/` + pageId + '/tabs';
        requestParams = {app_id: FB_APP_ID, access_token: accessToken};
    }
    FB.api(requestURL, httpMethod, requestParams, function(response) {
        if ( ! response.error) {
            if (response.data.length === 0) {
                FB.ui({
                    method: 'pagetab',
                    redirect_uri: window.location.href,
                }, function(response){
                    if(!response.error && typeof response.tabs_added != 'undefined' && response.tabs_added){
                        var selPageId;
                        if(response.tabs_added[pageId]){
                            selPageId = pageId;

                        }else if(Object.keys(response.tabs_added).length > 0){
                            //get one of the selected pages
                            selPageId = response.tabs_added[Object.keys(response.tabs_added)[0]];
                            store.facebook.page = selPageId;

                        }
                        onSuccess(selPageId);
                        FBMoveTab(selPageId, accessToken);
                    }else{
                        if ( !! onFailure) onFailure();
                    }
                });

            } else {
                onSuccess(response.data[0]);
                FBMoveTab(pageId, accessToken);
            }
        } else {
            if ( !! onFailure) onFailure();
        }
    });
}

const postMultiPhotosToWall = function(pageId, token, message, imageURLs, link, callback) {
    var imageIds = [];

    var isUploading = false;

    function cycle(index) {
        setTimeout(function() {
            if (imageIds.length === imageURLs.length) {
                return;
            }

            if (imageIds.length === index && !isUploading) {
                isUploading = true;

                var uploadPhoto = {
                    access_token: 	token,
                    url: 			imageURLs[index],
                    published: 		'false',
                };

                FB.api(`/${FB_VERSION}/` + pageId + '/photos', 'post', uploadPhoto, function(response) {
                    if(typeof response.id == 'undefined' || response.id == null){
                        FB.api(`/${FB_VERSION}/` + pageId + '/photos', 'post', uploadPhoto, function(response) {
                            imageIds.push(response.id);
                            index++;
                            isUploading = false;
                            cycle(index);
                        });
                    }else{
                        imageIds.push(response.id);
                        index++;
                        isUploading = false;
                        cycle(index);
                    }
                });
            } else {
                cycle(index);
            }
        }, 500);
    }

    cycle(0);

    var timer = setInterval(checkImagesUpload, 1000);
    function checkImagesUpload() {
        if (imageIds.length === imageURLs.length) {
            var attachedMedia = [];

            for (var i = 0; i < imageIds.length; i++) {
                if(typeof imageIds[i] != 'undefined' && imageIds[i] != null){
                    attachedMedia.push({ "media_fbid" : imageIds[i] });
                }
//					wallPost['attached_media[' + i + ']'] = '{ "media_fbid" : "' + imageIds[i] + '" }';
            }

            var wallPost = {
                access_token: token,
                message: message,
                attached_media: attachedMedia,
            };

            FB.api(`/${FB_VERSION}/` + pageId + '/feed', 'post', wallPost, function(response) {
                callback(response);
            });
            clearInterval(timer);
        }
    }
}

//---------------- TWITTER ----------------//
const authenticateTwitter = (changeAccount) => {
    const data = new URLSearchParams()
    data.append('type', 'authenticate-twitter')
    data.append('changeAccount', changeAccount)

    return axios.post(MyMenusPath, data)
}


const saveTwitterTokens = (token, tokenSecret, verifier) => {
    const data = new URLSearchParams()
    data.append('type', 'save-twitter-tokens')
    data.append('token', token)
    data.append('tokenSecret', tokenSecret)
    data.append('verifier', verifier)

    return axios.post(MyMenusPath, data)
}

const postToTwitter = (caption, menuId, token, tokenSecret, verifier, accessToken, accessTokenSecret) => {
    const data = new URLSearchParams()
    data.append('type', 'post-to-twitter')
    data.append('caption', caption)
    data.append('menuId', menuId)
    data.append('token', token)
    data.append('tokenSecret', tokenSecret)
    data.append('verifier', verifier)
    data.append('accessToken', accessToken)
    data.append('accessTokenSecret', accessTokenSecret)
    data.append('isTimberDesign', 'true')

    return axios.post(MyMenusPath, data)
}

export default {
    initFb,
    getFbUserName,
    getFbPermissions,
    getFbPages,
    postMultiPhotosToWall,

    authenticateTwitter,
    saveTwitterTokens,
    postToTwitter
}
